/* LYNDEN Intent-Rail v4.1 — show sticky only after TOC pills leave viewport */
(function () {
  if (window.__lydIntentRailV41) return;
  window.__lydIntentRailV41 = 1;

  function boot() {
    var src = document.getElementById('lyd-intent-rail');
    var sentinel = document.getElementById('lyd-intent-rail-sentinel');
    var toc = document.querySelector('.lyd-best .lyd-toc, .lyd-pg__content .lyd-toc, nav.lyd-toc');
    if (!src) return;

    function headerH() {
      var h = document.querySelector('.lyd-hv2-siteheader');
      if (h) {
        var r = h.getBoundingClientRect();
        if (r.height > 0) return Math.round(r.height);
      }
      var a = document.querySelector(
        'store-header.header, .shopify-section--header, header[role="banner"]'
      );
      if (a) {
        var r2 = a.getBoundingClientRect();
        if (r2.height > 0) return Math.round(r2.height);
      }
      return 58;
    }

    function setOffset() {
      var h = headerH();
      try {
        document.documentElement.style.setProperty('--lyd-header-offset', h + 'px');
      } catch (e) {}
      return h;
    }

    /* Only create float on mobile viewports */
    var bar = document.createElement('nav');
    bar.id = 'lyd-intent-rail-float';
    bar.className = 'lyd-intent-rail lyd-intent-rail--float';
    bar.setAttribute('aria-label', 'Abschnitte in diesem Vergleich');
    bar.innerHTML = src.innerHTML;
    bar.style.display = 'none';
    document.body.appendChild(bar);

    var lastShow = null;
    var ticking = false;

    function applyBarBox(top) {
      bar.style.position = 'fixed';
      bar.style.left = '0';
      bar.style.right = '0';
      bar.style.top = top + 'px';
      bar.style.width = '100%';
      bar.style.zIndex = '55';
      bar.style.margin = '0';
      bar.style.borderRadius = '0';
      bar.style.background = 'rgba(255,255,255,0.98)';
      bar.style.borderBottom = '1px solid #e8edf3';
      bar.style.boxShadow = '0 2px 12px rgba(13,40,64,0.1)';
      bar.style.boxSizing = 'border-box';
    }

    /**
     * Show sticky rail only AFTER the TOC pill block has scrolled away
     * (bottom of .lyd-toc is above the shop header).
     * Hysteresis avoids flicker at the threshold.
     */
    function shouldShow(top) {
      if (window.innerWidth > 900) return false;
      var edge;
      if (toc) {
        edge = toc.getBoundingClientRect().bottom;
      } else if (sentinel) {
        edge = sentinel.getBoundingClientRect().top;
      } else {
        return false;
      }
      if (lastShow) {
        /* stay visible until TOC bottom is clearly below header again */
        return edge <= top + 24;
      }
      /* appear only once TOC is fully above the sticky header */
      return edge <= top + 2;
    }

    function update() {
      ticking = false;
      if (window.innerWidth > 900) {
        if (lastShow !== false) {
          bar.classList.remove('is-visible');
          bar.style.display = 'none';
          lastShow = false;
        }
        return;
      }
      var top = setOffset();
      applyBarBox(top);
      var show = shouldShow(top);
      if (show !== lastShow) {
        lastShow = show;
        bar.classList.toggle('is-visible', show);
        bar.style.display = show ? 'block' : 'none';
      } else if (show) {
        bar.style.display = 'block';
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    function onChipClick(e) {
      var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) return;
      var id = (a.getAttribute('href') || '').slice(1);
      if (!id) return;
      var el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      var y =
        el.getBoundingClientRect().top +
        (window.pageYOffset || window.scrollY || 0) -
        (headerH() + 52);
      window.scrollTo(0, y < 0 ? 0 : y);
      var nodes = document.querySelectorAll(
        '#lyd-intent-rail-float .lyd-intent-rail__chip[data-rail-target]'
      );
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].classList.toggle(
          'is-active',
          nodes[i].getAttribute('data-rail-target') === id
        );
      }
    }

    bar.addEventListener('click', onChipClick);
    /* source is visually hidden — still allow TOC to handle its own links */
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    window.addEventListener('orientationchange', function () {
      setTimeout(update, 120);
    });

    setOffset();
    update();
    setTimeout(update, 300);
    setTimeout(update, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
